import script from "./agreement.vue?vue&type=script&setup=true&lang=js"
export * from "./agreement.vue?vue&type=script&setup=true&lang=js"

import "./agreement.vue?vue&type=style&index=0&id=7d738140&lang=less"

const __exports__ = script;

export default __exports__